/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
export const environment = {
  production: false,
  issuer: 'https://stage-signin.asco.org/oauth2/ausjvd4yftbauKQcJ0h7',
  clientId: '0oa2amvwbfkwcXsFI0h8',
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email']
};
